import {
  BlurStrength,
  ButtonMobileDisplay,
  HeaderSlot,
  HeaderV2Layout,
  IconAlignment,
  MegaMenuAlign,
  MegaMenuAspect,
  MegaMenuCardLayout,
  MegaMenuTrigger,
  MegaMenuWidth,
  UnitsMobileAlign,
  UnitsMobilePlacement,
  UnitsSelectorStyle,
  type ContactButtonConfig,
  type HeaderStateColors,
  type MegaMenuConfig,
  type UnitsSelectorConfig,
} from "./types";

export const FORMAT_SLOTS: Record<HeaderV2Layout, { top: HeaderSlot[]; bottom: HeaderSlot[] }> = {
  [HeaderV2Layout.BASIC]: {
    top: [HeaderSlot.LOGO, HeaderSlot.MENU, HeaderSlot.ACTIONS, HeaderSlot.BUTTONS, HeaderSlot.UNITS],
    bottom: [],
  },
  [HeaderV2Layout.EXTENDED]: {
    top: [HeaderSlot.LOGO, HeaderSlot.ACTIONS, HeaderSlot.UNITS],
    bottom: [HeaderSlot.MENU, HeaderSlot.BUTTONS],
  },
  [HeaderV2Layout.EXTENDED_TOP]: {
    top: [HeaderSlot.LOGO, HeaderSlot.ACTIONS, HeaderSlot.BUTTONS, HeaderSlot.UNITS],
    bottom: [HeaderSlot.MENU],
  },
};

export const COLOR_KEYS: (keyof HeaderStateColors)[] = [
  "background",
  "border",
  "links",
  "linksHover",
  "submenu",
  "submenuText",
  "submenuBorder",
  "submenuDescription",
  "submenuIcon",
  "icons",
  "buttonsText",
  "buttonsBackground",
  "buttonsBorder",
  "whatsappBackground",
  "whatsappIcon",
  "whatsappBorder",
  "phoneBackground",
  "phoneIcon",
  "phoneBorder",
  "outlineText",
  "outlineBorder",
  "linkText",
  "unitsText",
  "unitsBackground",
  "unitsBorder",
  "unitsDivider",
  "topBarBackground",
  "topBarBorder",
];

export const BLUR_PX: Record<BlurStrength, number> = {
  [BlurStrength.SM]: 4,
  [BlurStrength.MD]: 8,
  [BlurStrength.LG]: 16,
};

export const DEFAULT_MEGA_MENU: MegaMenuConfig = {
  columns: 4,
  aspect: MegaMenuAspect.FIXED,
  width: MegaMenuWidth.FULL,
  align: MegaMenuAlign.CENTER,
  trigger: MegaMenuTrigger.HOVER,
  cardLayout: MegaMenuCardLayout.ABOVE,
};

export const MEGA_MENU_COLUMNS = { min: 2, max: 8, default: 4 } as const;

export const DEFAULT_UNITS_SELECTOR: Required<Omit<UnitsSelectorConfig, "icon">> = {
  style: UnitsSelectorStyle.TEXT,
  showIcon: true,
  iconPosition: IconAlignment.LEFT,
  divider: true,
  mobilePlacement: UnitsMobilePlacement.BAR,
  mobileAlign: UnitsMobileAlign.CENTER,
  mobileDivider: true,
};

export const DEFAULT_CONTACT: Required<Omit<ContactButtonConfig, "icon">> = { mobileDisplay: ButtonMobileDisplay.DRAWER };

export const DEFAULT_CONTACT_RADIUS = "pill";

export const BAR_LAYOUT_REM = {
  barGap: 1.5,
  barGutter: 2,
  compactMaxWidth: 76,
  menuLogoMargin: 1,
  rightGroupGap: 1.25,
  desktopGroupGap: 0.75,
  contactSize: 2.25,
  divider: 0.0625,
  truncatedMinWidth: 5,
  buttonIcon: 1,
  buttonIconGap: 0.5,
} as const;

export const MENU_FIT_REFERENCE_VIEWPORT_PX = 1280;
